import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalService } from 'src/app/api/global.service';
import { TodosService, TodoStatusFilter, TodoView } from 'src/app/api/todos.service';

// The to do table in selection mode, for choosing the item something else (e.g. a time entry) is linked to.
// Has the same filters as the To Do page. Dismisses with the chosen to do, or null.
@Component({
  selector: 'app-todo-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class TodoSelectComponent implements OnInit {
  @Input() max_allowed_selections = 1;
  // The contact / company the item will be linked to - only their items (and ones with nobody assigned) are shown
  @Input() client_guid = '';
  @Input() company_guid = '';
  @Input() client_name = '';

  status: TodoStatusFilter = 'open';
  view: TodoView = 'mine';
  completed_days = 7;
  selected_team_member = '';
  team_members: any[] = [];
  quick_search = '';
  selected: any[] = [];

  readonly completed_day_options = [
    { days: 1, label: 'Today' },
    { days: 7, label: 'Past 7 Days' },
    { days: 30, label: 'Past 30 Days' },
    { days: 90, label: 'Past 90 Days' },
    { days: 1825, label: 'All Time' },
  ];

  constructor(private modalController: ModalController, public globalService: GlobalService, public todosService: TodosService) { }

  async ngOnInit() {
    this.team_members = await this.todosService.GetTeamMembers();
  }

  SetStatus(status: TodoStatusFilter) {
    this.status = status;
    this.selected = [];
  }

  SetView(view: TodoView) {
    this.view = view;
    this.selected = [];
  }

  Select() {
    this.modalController.dismiss(this.selected[0] || null);
  }

  Close() {
    this.modalController.dismiss(null);
  }
}
